import { buildCollectionPageJsonLd, buildItemListJsonLd } from "@/lib/shared/seo";
import { buildProductSeoDescription } from "@/lib/shared/seoContent";
import type { ProductForClient } from "@/lib/shared/types/interfaces";
import { ProductGridHeader, type ProductGridPriceFilter } from "./ProductGridHeader";

interface ProductCollectionStructuredDataProps {
  locale: string;
  pathname: string;
  title: string;
  description?: string;
  products: ProductForClient[];
  priceFilter?: ProductGridPriceFilter;
}

function getProductDescription(product: ProductForClient): string | undefined {
  return buildProductSeoDescription(product);
}

export function ProductCollectionStructuredData({
  locale,
  pathname,
  title,
  description,
  products,
  priceFilter,
}: ProductCollectionStructuredDataProps) {
  const collectionJsonLd = buildCollectionPageJsonLd({
    locale,
    pathname,
    title,
    description,
  });
  const itemListJsonLd = buildItemListJsonLd(
    locale,
    products.map((product) => ({
      name: product.name,
      pathname: `/products/${product.sku}`,
      image: product.images?.[0]?.src,
      description: getProductDescription(product),
    })),
  );

  return (
    <>
      <ProductGridHeader
        title={title}
        description={description}
        priceFilter={priceFilter}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(collectionJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(itemListJsonLd) }}
      />
    </>
  );
}
